import { useGT } from 'gt-react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import {
  OutboundEmailViewerBody,
  useOutboundEmailViewData,
} from './outbound-email-viewer-shared';

interface Props {
  outboundEmailId: string | null;
  onClose: () => void;
}

/**
 * Side sheet that shows a sent (outbound) email — the sent-side counterpart
 * of InboundEmailDetailSheet. Used by the AR customer profile's sent-emails
 * tab and the collection-thread activity timeline. Shares its body/data with
 * other sent-email surfaces via outbound-email-viewer-shared.
 */
export function OutboundEmailDetailSheet({ outboundEmailId, onClose }: Props) {
  const gt = useGT();
  const isOpen = !!outboundEmailId;
  const { emailData, isLoading, subject } = useOutboundEmailViewData(
    outboundEmailId ?? undefined,
    isOpen,
  );

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <SheetContent
        side="right"
        className="w-[550px] sm:max-w-[550px] p-0 overflow-hidden"
      >
        <SheetHeader className="px-4 py-3 border-b">
          <SheetTitle className="text-sm">
            {subject ??
              gt('Email Preview', {
                context: 'sheet title, sent email preview fallback',
              })}
          </SheetTitle>
        </SheetHeader>
        <OutboundEmailViewerBody emailData={emailData} isLoading={isLoading} />
      </SheetContent>
    </Sheet>
  );
}
